import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import hexOpacity from '@deprecated-ui/utils/hexOpacity';
import { useDispatch, useSelector } from 'react-redux';
import { parseStreamPostContent } from 'utils/stream';
import {
  effects as streamEffects,
  selectors as streamSelectors,
} from 'lib/entities/stream';
import { useMemo } from 'react';
import StreamCompose from '../../StreamCompose';
import { COMPOSE_MODE } from '../../StreamCompose/constants';
import { Modal } from './styled';
import { StreamPostData } from '../../../../@types/stream';

interface ModalEditPostProps {
  post: StreamPostData;
  onCancel: () => void;
  [key: string]: any;
}

function ModalEditPost({ post, onCancel, ...props }: ModalEditPostProps) {
  const selectedPost = useMemo(() => parseStreamPostContent(post), [post]);

  const dispatch = useDispatch();
  const {
    updatePostStream: { isLoading },
  } = useSelector(streamSelectors);

  const handleEditPost = async (val) => {
    const data = {
      ...val,
      postid: post.postid,
    };

    // @ts-ignore
    const update = await dispatch(streamEffects.updatePostStream({ ...data }));

    // @ts-ignore
    const { error } = update.payload;

    if (!error) {
      onCancel();
    }

    return error;
  };

  return (
    <Modal
      {...props}
      onCancel={onCancel}
      centered
      maskStyle={{ backgroundColor: `${color.black}${hexOpacity(80)}` }}
      title={
        <Text size="18px" height="44px" family="bold" align="center">
          Edit on Idea
        </Text>
      }
      footer={null}
      width={660}
      bodyStyle={{ padding: '0px' }}
      transitionName=""
      maskTransitionName=""
      destroyOnClose
    >
      <StreamCompose
        mode={COMPOSE_MODE.EDIT}
        initialValues={selectedPost}
        isLoading={isLoading}
        onSubmit={handleEditPost}
        onCancel={onCancel}
      />
    </Modal>
  );
}

export default ModalEditPost;
